import { render, staticRenderFns } from "./InstagramInstantwinAnalyticsPublicTabs.vue?vue&type=template&id=b98222fc&scoped=true"
import script from "./InstagramInstantwinAnalyticsPublicTabs.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinAnalyticsPublicTabs.vue?vue&type=script&lang=ts"
import style0 from "./InstagramInstantwinAnalyticsPublicTabs.vue?vue&type=style&index=0&id=b98222fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98222fc",
  null
  
)

export default component.exports